export default "__VITE_ASSET__Bf84MYA4__"